@if (orderParkingVM) {
  <mat-toolbar class="mat-elevation-z8">
    {{ 'PARKING_ORDER_TIME_EDIT.PARKING_TIME' | transloco }}
    <div class="spacer"></div>
    {{ 'PARKING_ORDER_TIME_EDIT.CAR_NUMBER' | transloco }} : {{orderParkingVM.carId}}
  </mat-toolbar>
}

@if (isLoading) {
  <div class="spinner">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
}

<mat-dialog-content class="mt-3" [style.opacity]="isLoading ? 0.6 : 1">

  <div class="my-2">
    <form [formGroup]="editOrderParkingTimeForm">
      <table>
        @if(!isSkavsta){
          <!-- ===== DEPARTURE SECTION ===== -->
          <tr>
            <td colspan="2">
              <strong>Departure</strong>
            </td>
          </tr>

          <tr>
            <td colspan="2">
              <mat-radio-group formControlName="departureType" class="radio-group"
                class="margin-bottom-20-important">
                <mat-radio-button value="flight">Flight</mat-radio-button>
                <mat-radio-button value="hotel">Hotel</mat-radio-button>
              </mat-radio-group>
            </td>
          </tr>

          <!-- Departure – Flight fields -->
          @if (editOrderParkingTimeForm.get('departureType').value === 'flight') {
            <tr>
              <td colspan="2">
                <mat-form-field appearance="outline" (click)="depDate.open()">
                  <mat-label>{{ 'PARKING_ORDER_TIME_EDIT.FLIGHT_DATE_DEPARTURE' | transloco }}</mat-label>
                  <input matInput [matDatepicker]="depDate" formControlName="departureDate"
                    (dateChange)="departureDateChanged()">
                  <mat-datepicker-toggle matSuffix [for]="depDate"></mat-datepicker-toggle>
                  <mat-datepicker touchUi #depDate></mat-datepicker>
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'PARKING_ORDER_TIME_EDIT.DEPARTURE_FLIGHT' | transloco }}</mat-label>
                  <input type="text" matInput formControlName="departureFlight" [matAutocomplete]="autoDep"
                    #depTrigger="matAutocompleteTrigger">
                  <mat-autocomplete #autoDep="matAutocomplete" [displayWith]="displayDepartureFn.bind(this)"
                    (optionSelected)="departureFlightSelected($event.option.value)">
                    @for (departure of filteredDepartures | async; track departure) {
                      <mat-option [value]="departure"
                        (mousedown)="selectDepartureFlight(departure, depTrigger, $event)"
                        (touchstart)="selectDepartureFlight(departure, depTrigger, $event)">
                        <div class="display-flex">
                          <span>{{departure.departureCode}} {{departure.arrivalStation}} :
                          {{departure.scheduledDeparture | date: 'HH:mm'}}</span>
                          <div class="spacer"></div>
                          <span>{{departure.stationCode}} : {{departure.terminalName}}</span>
                        </div>
                      </mat-option>
                    }
                  </mat-autocomplete>
                  <mat-icon matSuffix>flight_takeoff</mat-icon>
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'FORM.ARRIVAL_TIME' | transloco }}</mat-label>
                  <mat-select formControlName="departureArrivalTimeToParking">
                    @for (opt of departureArrivalTimeOptions; track opt) {
                      <mat-option [value]="opt.value">
                        <div class="display-flex">
                          <span class="mr-2">{{opt.label}}</span>
                        </div>
                      </mat-option>
                    }
                  </mat-select>
                  <mat-icon matSuffix>schedule</mat-icon>
                </mat-form-field>
              </td>
            </tr>
          }

          <!-- Departure – Hotel fields -->
          @if (editOrderParkingTimeForm.get('departureType').value === 'hotel') {
            <tr>
              <td colspan="2">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'PARKING_ORDER_TIME_EDIT.SHUTTLE_TO_TERMINAL' | transloco }}</mat-label>
                  <mat-select formControlName="departureShuttleToTerminal">
                    @for (option of terminalOptions; track option) {
                      <mat-option [value]="option.value">
                        {{option.name}}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </td>
            </tr>
          }

          @if (editOrderParkingTimeForm.get('departureType').value === 'hotel') {
            <tr>
              <td>
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'PARKING_ORDER_TIME_EDIT.SHUTTLE_FROM_PARKING_TO_TERMINAL_DATE' | transloco }}</mat-label>
                  <input matInput formControlName="departureShuttleDate" [matDatepicker]="depShuttleDate">
                  <mat-datepicker-toggle matSuffix [for]="depShuttleDate"></mat-datepicker-toggle>
                  <mat-datepicker #depShuttleDate></mat-datepicker>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'PARKING_ORDER_TIME_EDIT.SHUTTLE_FROM_PARKING_TO_TERMINAL_TIME' | transloco }}</mat-label>
                  <input matInput type="time" formControlName="departureShuttleTime">
                  <mat-icon matSuffix>schedule</mat-icon>
                </mat-form-field>
              </td>
            </tr>
          }

          <!-- Departure – Passengers & Baggage -->
          <tr>
            <td colspan="2">
              <div class="display-flex">
                <mat-form-field appearance="outline" class="form-field-200-mr-10">
                  <mat-label>Passagerare</mat-label>
                  <input formControlName="departurePassengers" type="number" min="1" matInput
                    placeholder="Välj antal passagerare">
                  <mat-icon matSuffix>supervisor_account</mat-icon>
                </mat-form-field>

                <div class="flex-column-mr-10-mb-22">
                  <div class="label-small-gray">Baggage?</div>
                  <mat-radio-group formControlName="departureBaggage" class="radio-group margin-0-important">
                    <mat-radio-button value="yes">Yes</mat-radio-button>
                    <mat-radio-button value="no">No</mat-radio-button>
                  </mat-radio-group>
                </div>
              </div>
            </td>
          </tr>

          <tr>
            <td colspan="2">
              <mat-divider></mat-divider>
              &nbsp;
            </td>
          </tr>

          <!-- ===== ARRIVAL SECTION ===== -->
          <tr>
            <td colspan="2">
              <strong>Arrival</strong>
            </td>
          </tr>

          <tr>
            <td colspan="2">
              <mat-radio-group formControlName="arrivalType" class="radio-group margin-bottom-20-important">
                <mat-radio-button value="flight">Flight</mat-radio-button>
                <mat-radio-button value="hotel">Hotel</mat-radio-button>
              </mat-radio-group>
            </td>
          </tr>

          <!-- Arrival – Flight fields -->
          @if (editOrderParkingTimeForm.get('arrivalType').value === 'flight') {
            <tr>
              <td colspan="2">
                <mat-form-field appearance="outline" (click)="arrDate.open()">
                  <mat-label>{{ 'PARKING_ORDER_TIME_EDIT.FLIGHT_DATE_ARRIVAL' | transloco }}</mat-label>
                  <input matInput [matDatepicker]="arrDate" formControlName="arrivalDate"
                    (dateChange)="arrivalDateChanged()">
                  <mat-datepicker-toggle matSuffix [for]="arrDate"></mat-datepicker-toggle>
                  <mat-datepicker touchUi #arrDate></mat-datepicker>
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'PARKING_ORDER_TIME_EDIT.ARRIVAL_FLIGHT' | transloco }}</mat-label>
                  <input type="text" matInput formControlName="arrivalFlight" [matAutocomplete]="autoArr"
                    #arrTrigger="matAutocompleteTrigger">
                  <mat-autocomplete #autoArr="matAutocomplete" [displayWith]="displayArrivalFn.bind(this)">
                    @for (arrival of filteredArrivals | async; track arrival) {
                      <mat-option [value]="arrival"
                        (mousedown)="selectArrivalFlight(arrival, arrTrigger, $event)"
                        (touchstart)="selectArrivalFlight(arrival, arrTrigger, $event)">
                        <div class="display-flex">
                          <span>{{arrival.arrivalCode}} {{arrival.departureStation}} :
                          {{arrival.scheduledArrival | date: 'HH:mm'}}</span>
                          <div class="spacer"></div>
                          <span>{{arrival.stationCode}} : {{arrival.terminalName}}</span>
                        </div>
                      </mat-option>
                    }
                  </mat-autocomplete>
                  <mat-icon matSuffix>flight_land</mat-icon>
                </mat-form-field>
              </td>
            </tr>
          }

          <!-- Arrival – Hotel fields -->
          @if (editOrderParkingTimeForm.get('arrivalType').value === 'hotel') {
            <tr>
              <td colspan="2">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'PARKING_ORDER_TIME_EDIT.SHUTTLE_FROM_TERMINAL' | transloco }}</mat-label>
                  <mat-select formControlName="arrivalShuttleFromTerminal">
                    @for (option of terminalOptions; track option) {
                      <mat-option [value]="option.value">
                        {{option.name}}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </td>
            </tr>
          }

          @if (editOrderParkingTimeForm.get('arrivalType').value === 'hotel') {
            <tr>
              <td>
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'PARKING_ORDER_TIME_EDIT.SHUTTLE_FROM_TERMINAL_TO_PARKING_DATE' | transloco }}</mat-label>
                  <input matInput formControlName="arrivalShuttleDate" [matDatepicker]="arrShuttleDate">
                  <mat-datepicker-toggle matSuffix [for]="arrShuttleDate"></mat-datepicker-toggle>
                  <mat-datepicker #arrShuttleDate></mat-datepicker>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'PARKING_ORDER_TIME_EDIT.SHUTTLE_FROM_TERMINAL_TO_PARKING_TIME' | transloco }}</mat-label>
                  <input matInput type="time" formControlName="arrivalShuttleTime">
                  <mat-icon matSuffix>schedule</mat-icon>
                </mat-form-field>
              </td>
            </tr>
          }

          <!-- Arrival – Passengers & Baggage -->
          <tr>
            <td colspan="2">
              <div class="display-flex">
                <mat-form-field appearance="outline" class="form-field-200-mr-10">
                  <mat-label>Passagerare</mat-label>
                  <input formControlName="arrivalPassengers" type="number" min="1" matInput
                    placeholder="Välj antal passagerare">
                  <mat-icon matSuffix>supervisor_account</mat-icon>
                </mat-form-field>

                <div class="flex-column-mr-10-mb-22">
                  <div class="label-small-gray">Baggage?</div>
                  <mat-radio-group formControlName="arrivalBaggage" class="radio-group margin-0-important">
                    <mat-radio-button value="yes">Yes</mat-radio-button>
                    <mat-radio-button value="no">No</mat-radio-button>
                  </mat-radio-group>
                </div>
              </div>
            </td>
          </tr>
        }

        <!-- ===== PARKING TIME SUMMARY ===== -->
        <tbody class="disabled-row">
          @if (!isSkavsta) {
            <tr>
              <td colspan="2"><mat-divider></mat-divider>&nbsp;</td>
            </tr>
          }
          <tr>
            <td colspan="2">
              {{ 'PARKING_ORDER_TIME_EDIT.PARKING_TIME' | transloco }}
              <br>&nbsp;
              </td>
            </tr>
            <tr>
              <td class="width-300">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'PARKING_ORDER_TIME_EDIT.PARKING_FROM' | transloco }}</mat-label>
                  <input matInput [value]="computedParkingFrom | date:'yyyy-MM-dd'" readonly>
                  <mat-icon matSuffix>calendar_today</mat-icon>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'PARKING_ORDER_TIME_EDIT.PARKING_FROM_TIME' | transloco }}</mat-label>
                  <input matInput [value]="computedParkingFrom | date:'HH:mm'" readonly>
                  <mat-icon matSuffix>schedule</mat-icon>
                </mat-form-field>
              </td>
            </tr>
            <tr>
              <td>
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'PARKING_ORDER_TIME_EDIT.PARKING_TO' | transloco }}</mat-label>
                  <input matInput [value]="computedParkingTo | date:'yyyy-MM-dd'" readonly>
                  <mat-icon matSuffix>calendar_today</mat-icon>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'PARKING_ORDER_TIME_EDIT.PARKING_TO_TIME' | transloco }}</mat-label>
                  <input matInput [value]="computedParkingTo | date:'HH:mm'" readonly>
                  <mat-icon matSuffix>schedule</mat-icon>
                </mat-form-field>
              </td>
            </tr>
          </tbody>

          <!-- ===== CREATE PAYMENT ===== -->

          @if(!isSkavsta){
            @if (additionalPaymentAmount > 0) {
              <tr>
                <td colspan="2"><mat-divider></mat-divider>&nbsp;</td>
              </tr>
              <tr>
                <td colspan="2">
                  <div class="label-ml-10-mt-5">
                    Additional payment: {{ additionalPaymentAmount }} kr
                  </div>
                  <!-- <div style="display: flex; flex-direction: column; margin-top: 10px; margin-bottom: 22px;">
                  <div class="label-small-gray-ml-10">Create payment?</div>
                  <mat-radio-group formControlName="createPayment" class="radio-group"
                    class="margin-top-5-important">
                    <mat-radio-button value="yes">Yes</mat-radio-button>
                    <mat-radio-button value="no">No</mat-radio-button>
                  </mat-radio-group>
                </div> -->
                @if (overbooking == true) {
                  <div class="label-ml-10-mt-5">
                    Parking is full. Proceed with overbooking.
                  </div>
                }
              </td>
            </tr>
          }
        }
      </table>
    </form>
  </div>

</mat-dialog-content>

<mat-dialog-actions class="mt-2 mb-4 mx-3" align="end" [style.opacity]="isLoading ? 0.6 : 1">
  <button mat-raised-button color="primary" [disabled]="isLoading || !isFormValid"
  (click)="saveChanges()">SPARA</button>
  <button mat-button mat-dialog-close [disabled]="isLoading">STÄNG</button>
</mat-dialog-actions>